// const isiOS = () => {
//   return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window['MSStream'];
// }

const isiOS = () => {
  return (
    [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod',
    ].includes(navigator.platform) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
  );
};

export default isiOS;
